import {Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {LoginResponse} from '../nav-bar/nav-bar.component';

export interface DialogData {
  title: string;
  cancelButtonLabel: string;
  submitButtonLabel: string;
  email: string;
}

@Component({
  selector: 'app-newpasswort-form',
  templateUrl: './newPasswort-form.component.html',
  styleUrls: ['./newPasswort-form.component.scss']
})
export class NewPasswortFormComponent implements OnInit {

  bar0: string;
  bar1: string;
  bar2: string;
  bar3: string;
  bar4: string;
  public scorePW = 0;
  public bHideOldPassword: boolean;
  public bHideNewPasswordOne: boolean;
  public bHideNewPasswordTwo: boolean;

  constructor(public dialogRef: MatDialogRef<NewPasswortFormComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private http: HttpClient)
  {
    dialogRef.disableClose = true;
  }

  public barLabel = 'Passwortstärke:';

  private colors = ['#F00', '#F90', '#FF0', '#9F0', '#0F0'];

  public account = {
    pw: null
  };

  public newPassswortForm = new FormGroup({
    altesPasswort: new FormControl('', [Validators.required, Validators.maxLength(255)]),
    neuesPasswort1: new FormControl('', [Validators.required, Validators.maxLength(255)]),
    neuesPasswort2: new FormControl('', [Validators.required, Validators.maxLength(255)]),
  });

  public showHint: boolean;

  ngOnInit(): void {
    this.showHint = false;
    this.bHideOldPassword = true;
    this.bHideNewPasswordOne = true;
    this.bHideNewPasswordTwo = true;
  }




  public changePasswort(): any {
    // 1. Check ob neuesPasswort1 und 2 gleich sind
    if ( this.newPassswortForm.value.neuesPasswort1 !== this.newPassswortForm.value.neuesPasswort2){
      // User informieren das Passwort 1 und 2 nicht identisch sind
      console.log('Passwörter sind nicht identisch');
      return;
    }

    // 2. Check ob altes passwort richtig ist
    // Check if user exists
    this.getUser(this.data.email, this.newPassswortForm.value.altesPasswort).subscribe((data: LoginResponse) => {
      if (data.responce == '0'){
        // Passwort Ändern
        const response = this.http.get
        (
          `https://local.curion.ch/AccMan/chgpwd.php?app=1003&email=${this.data.email}&pwd=${this.newPassswortForm.value.neuesPasswort1}`,
          {responseType: 'text'}
        );
        response.subscribe();
        this.dialogRef.close(true);
        // Passwort erfolgreich geändert
      }else{
        // Nachricht das Passwort falsch ist.
        this.showHint = true;
      }
    });

  }
  // tslint:disable-next-line:typedef
  public noHandleClick() {
    this.dialogRef.close(false);
  }

  public getErrorMessage(Feld: string): string {
    const formControl = this.newPassswortForm.get(Feld);
    if (formControl.hasError('required')){
      return`pages.login.newPasswortDialog.error.${Feld}.required`;
    }
    return 'pages.login.newPasswortDialog.error.generic';
  }
  /* ENDE Ja / Nein Buttons in im Löschen Bestätigungsformular */
  /* ENDE Menue vor dem Löschen bzw. Werte dem ja Pfad zuweisen */

  public measureStrength(pass: string): number{
    let score = 0;
    // award every unique letter until 5 repetitions
    const letters = {};

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < pass.length; i++) {
      letters[pass[i]] = (letters[pass[i]] || 0) + 1;
      score += 5.0 / letters[pass[i]];
    }
    // bonus points for mixing it up
    const variations = {
      digits: /\d/.test(pass),
      lower: /[a-z]/.test(pass),
      upper: /[A-Z]/.test(pass),
      nonWords: /\W/.test(pass)
    };

    let variationCount = 0;
    // tslint:disable-next-line:forin
    for (const check in variations) {
      variationCount += (variations[check]) ? 1 : 0;
    }
    score += (variationCount - 1) * 10;
    console.log(score);
    this.scorePW = score;
    return Math.trunc(score);
  }

  public getColor(score: number): any {
    let idx = 0;
    if (score >= 85) {
      idx = 4;
    } else if (score >= 70) {
      idx = 3;
    } else if (score >= 40) {
      idx = 2;
    } else if (score >= 20) {
      idx = 1;
    }
    return {
      idx: idx + 1,
      col: this.colors[idx]
    };
  }

  checkPw(password: string): void {
    this.setBarColors(5, '#DDD');
    if (password) {
      const c = this.getColor(this.measureStrength(password));
      this.setBarColors(c.idx, c.col);
    }
  }

  private setBarColors(count: number, col: string) {
    // tslint:disable-next-line:variable-name
    for (let _n = 0; _n < count; _n++) {
      this['bar' + _n] = col;
    }
  }

  // Returns an observable with the login response, we need to subscribe to it to validate the results
  public getUser(email, passwort): any{
    return this.http.get<LoginResponse>
    (
      `https://local.curion.ch/AccMan/verify.php?app=1003&email=${email}&pwd=${passwort}`,
      {responseType: 'json'}
    );
  }

}
